(ns frontend.ux-overhaul.listing.sale-agreement.view
  (:require [common.localization :as loc]
            [common.opensearch.row :as os-row]
            [frontend.routing :as routing]
            [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.ux-overhaul.listing.generic.event :as generic-event]
            [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
            [frontend.ux-overhaul.listing.generic.menu-actions :as menu-actions]
            [frontend.ux-overhaul.listing.generic.view :as listing]
            [frontend.ux-overhaul.listing.sale-agreement.event :as sale-agreement-event]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(def listing-id "sale-agreement-listing")

(defn- open-sale-agreement!
  [value]
  (when-let [entity-id (os-row/entity-id value)]
    (routing/open-entity {:db/id       entity-id
                          :entity/type :entity.type/sale-agreement})))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id           listing-id
         :entity-type          :entity.type/sale-agreement
         :pipeline-id          nil
         :filters              {:enabled? true
                                :view-id :sale-agreement
                                :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes #{:grid :kanban :gallery :list}
         :toolbar-actions      [{:id       :create-sale-agreement
                                 :label    (loc/tr :sale-agreement-add-button)
                                 :visible? true
                                 :enabled? true
                                 :event    [::sale-agreement-event/create-sale-agreement]}
                                {:id                  :bulk-edit-sale-agreements
                                 :label               (loc/tr :bulk-edit)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :event               [::sale-agreement-event/open-bulk-edit {:listing-id listing-id}]}
                                {:id                  :bulk-delete-sale-agreements
                                 :label               (loc/tr :confirm-delete-selected-button)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :variant             :danger
                                 :event               [::sale-agreement-event/bulk-delete-selected {:listing-id listing-id}]}
                                {:id       :export-sale-agreements
                                 :label    (loc/tr :save-as-excel)
                                 :visible? true
                                 :enabled? true
                                 :event    [::sale-agreement-event/export-grid {:listing-id listing-id}]}
                                {:id       :export-sale-agreements-with-persons
                                 :label    (loc/tr :save-as-excel-all-data)
                                 :visible? true
                                 :enabled? true
                                 :event    [::sale-agreement-event/export-grid-with-persons {:listing-id listing-id}]}
                                (menu-actions/field-requirements-action {:entity-type :entity.type/sale-agreement})]}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      [:<>
       [listing/view
        {:listing-id               listing-id
         :title                    (loc/tr :sale-agreements)
         :show-view-mode-selector? true
         :query-placeholder        (loc/tr :listing.sale-agreement/search-placeholder)
         :on-create-first-item     #(rf/dispatch [::sale-agreement-event/create-sale-agreement])
         :on-row-clicked           open-sale-agreement!
         :on-card-clicked          open-sale-agreement!}]
       [bulk-actions/bulk-edit-modal
        {:listing-id  listing-id
         :entity-type :entity.type/sale-agreement}]
       [menu-actions/field-requirements-modal]])}))
